import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React from 'react';
import { Form } from '../../Form';
export const ModalDialogForm = (props) => {
    var _a, _b, _c;
    const formRef = React.useRef(null);
    return (React.createElement(Dialog, { maxWidth: ((_a = props.config.modal) === null || _a === void 0 ? void 0 : _a.maxWidth) === 'full' ? false : (_b = props.config.modal) === null || _b === void 0 ? void 0 : _b.maxWidth, fullWidth: (_c = props.config.modal) === null || _c === void 0 ? void 0 : _c.fullWidth, open: !!props.open, onClose: (event, reason) => {
            if (reason === 'escapeKeyDown') {
                props.onCancel();
            }
        }, TransitionProps: { onExited: props.onCloseAfterTransition } },
        (props.config.modal.title || props.config.label) && (React.createElement(DialogTitle, null, props.config.modal.title || props.config.label)),
        React.createElement(DialogContent, null,
            React.createElement(Box, { pt: 1 },
                React.createElement(Form, { ref: formRef, config: {
                        type: 'form',
                        children: props.config.modal.children,
                        onLoad: props.config.modal.onLoad,
                        onSubmit: props.config.modal.onSubmit,
                    }, data: props.data, formParams: Object.assign(Object.assign({}, props.formParams), { parentModalWidgetHandler: props.parentModalWidgetHandler }), valueProviders: props.valueProviders, subFormProviders: props.subFormProviders, rules: props.rules, globalWidgetConfig: props.globalWidgetConfig, widgets: props.widgets, hideFormControls: true, onSubmit: (data) => {
                        props.onSave(data);
                        return Promise.resolve();
                    } }))),
        React.createElement(DialogActions, null,
            React.createElement(Button, { color: 'primary', onClick: props.onCancel, "data-test": 'cancel-button' }, props.config.modal.cancelButtonLabel || 'Cancel'),
            React.createElement(Button, { color: 'primary', onClick: () => {
                    var _a;
                    return (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.submit().catch(() => {
                        // error is handled by the Form component itself
                    });
                }, "data-test": 'save-button' }, props.config.modal.saveButtonLabel || 'Save'))));
};
